import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupGoalsLoadAction } from '../../domains/groupGoals/actions.types';

import { GroupGoals } from './types';

export const initialState: GroupGoals = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupGoals, GroupGoalsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_GOALS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_GOALS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupGoals);
    case 'GROUP_GOALS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
